import EarthMarker from './EarthMarker'

export default EarthMarker
